module.exports = __webpack_public_path__ + "static/emblem-8203fa5be577c8b6c0543d69a7c5520c.png";